import moment from "moment-timezone";

import { FilterTypeOptionDateRange } from "src/core/dashboard/api/dashboard.api";
import { GetWidgetDateRangeParam } from "src/core/dashboard/api/widget-data.api";

/**
 * Helper that takes the UI shape of dateRange filters and transforms it into the shape the API requires.
 */
export const dateTransformer = (dateRange: FilterTypeOptionDateRange): GetWidgetDateRangeParam => {
  if (dateRange.custom) {
    return {
      start: moment(dateRange.custom.start).format("YYYY-MM-DD"),
      end: moment(dateRange.custom.end).format("YYYY-MM-DD")
    };
  }

  return {
    start: moment().subtract(dateRange.days, "d").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD")
  };
};